var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModeHeating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_134648715180821714366454720171161288399",
    d: "M13.958 3.911c-2.53.703-2.993 2.697-2.83 3.964C9.325 5.807 9.399 3.427 9.399 0 3.61 2.128 4.956 8.262 4.782 10.125c-1.455-1.162-1.73-3.938-1.73-3.938-1.537.772-2.308 2.83-2.308 4.5 0 4.04 3.358 7.313 7.5 7.313 4.142 0 7.5-3.274 7.5-7.313 0-2.4-1.807-3.507-1.786-6.776zM8.533 16.875c-3.665 0-6.635-3.014-6.635-6.398 0-.787.018-1.424.577-2.04-.061.357.806 3.406 3.637 3.247-.123-2.317-.765-7.993 2.22-9.955-.264 3.084.51 7.228 3.967 7.833-.198-1.236-.175-3.295.714-3.675.096 1.895 1.533 3.065 1.533 4.886 0 3.298-3.273 6.102-6.013 6.102z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_109297444019516941600397728936406247055",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hinava_random_uuid_134648715180821714366454720171161288399"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#hinava_random_uuid_134648715180821714366454720171161288399"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ff4700",
    mask: "url(#hinava_random_uuid_109297444019516941600397728936406247055)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    transform: "translate(-4 -3)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeHeating);
export default __webpack_public_path__ + "static/media/mode_heating.92453fe9957fb83236d0fae9c07974d3.svg";
export { ForwardRef as ReactComponent };